module.exports = __webpack_public_path__ + "static/media/home_banner.f4ff5aad.webp";